<template>
  <SbIconButton
    class="sb-modal__close-button"
    tooltip-position="top"
    icon="x"
    variant="quaternary"
    is-clear
    size="small"
    :label="i18n(locale, 'Close Modal')"
    @click="handleCloseModal"
  />
</template>

<script lang="ts">
import SbIconButton from '../../IconButton'
import i18n from '../../../i18n'

export default {
  name: 'SbModalCloseButton',

  components: {
    SbIconButton,
  },

  inject: ['modalContext'],

  props: {
    locale: {
      type: String,
      default: 'en',
    },
  },

  computed: {
    context() {
      return this.modalContext()
    },
  },

  methods: {
    i18n,
    handleCloseModal() {
      this.context.closeModal()
    },
  },
}
</script>
